export default {
  // locale
  sk: "Slovenský",
  en: "English",

  // login
  "Welcome to chefCarte": "Vitajte v chefCarte",
  "Log in with Google": "Prihlásenie cez Google",
  "Log in with Email": "Prihlásenie cez Email",
  "You don't have an account? You can": "Nemáte účet? Môžete si ho",
  "create one": "vytvoriť",
  "Enter your email": "Zadajte prihlasovací email",
  "Enter your password": "Zadajte prihlasovacie heslo",
  "Log in": "Prihlásiť",
  "All log in options": "Späť na všetky možnosti prihlásenia",
  "Forgot password": "Zabudol som heslo",
  "You do not have persmissions to access this route":
    "Nemáte oprávnenia na prístup k tejto ceste",
  "Auth error occured": "Vyskytla sa chyba autentifikácie",
  "If interested, take a look at our": "V prípade záujmu si prelistujte náš ",
  "Privacy Policy document": "dokument o spracovaní osobných údajov",
  "try it out, it's easy!": "vyskúšajte, neobanujete!",
  "Log in with Google or create your account.":
    "Prihláste sa cez Google alebo si vytvorte účet.",

  // multiselect
  "None selected": "Žiadne vybrané",
  "Selected {0}": "Vybraté {0}",
  "No options": "Žiadne možnosti",

  // sign up
  "Sign up": "Vytvoriť účet",
  Password: "Heslo",
  "Or go back to login": "Späť na prihlásenie cez email",
  "Confirm password": "Potvrdenie hesla",
  "Privacy Policy": "dokumentu o spracovaní osobných údajov",
  "I understand that my data are protected according to":
    "Rozumiem, že moje dáta sú chránené v zmysle ",

  // reset password
  "Send reset password to e-mail": "Poslať reset hesla na e-mail",
  "Reset password": "Resetovať heslo",
  "Password reset e-mail sent.":
    "Email s inštrukciami na obnovenie hesla bol úspešne odoslaný.",

  // validations
  "The field is requied": "Pole je povinné",
  "The field must match pattern {0}": "Pole musí byť v tvare {0}",
  "The field must be a valid email":
    "Pole musí obsahovať platnú emailovú adresu",
  "The field length must be from {0} to {1}":
    "Pole musí mať veľkosť od {0} do {1}",
  "The field must have a same value as {0}": "Pole musí byť rovnake ako {0}",
  "The field must be non-empty": "Pole nemôže byť prázdne",
  "The field length must be less than {0}": "Pole musí byť menšie ako {0}",
  "The field length must be at least {0}": "Pole musí mať aspoň {0} znakov",
  "The number field must have fixed point at most {0} length":
    "Pocet desatinych miest môže byť najviac {0}",
  "Number of selected items must be less than {0}":
    "Počet vybraných položiek musí byť menší ako {0}",
  "The field must be non blank": "Pole musí byť neprázdne",
  "You must agree with GDPR": "Súhlas s spracovaním údajov je potrebný",

  // nav
  Offer: "Menu",
  Offers: "Ponuky",
  Meals: "Jedlá",
  Screens: "Obrazovky",
  Settings: "Nastavenia",
  "Log Out": "Odhlásenie",
  Close: "Zatvoriť",

  // offer
  "Add meal here": "Pridajte jedlá zo zoznamu",
  "List is empty": "Zoznam je prázdny",
  "Show meals list": "Zobraziť zoznam jedál",
  "Show menu": "Zobraziť menu",
  "Move up": "Presunúť vyššie",
  "Move down": "Presunúť nižšie",

  // meals
  "Food list": "Zoznam jedál",
  Create: "Nové",
  "Search meals...": "Vyhľadať jedlá...",
  "Clear text": "Vymazať text",

  // new meal / edit meal
  "Add new meal": "Vytvorenie nového jedla",
  "Editing meal": "Úprava jedla",
  "Name *": "Názov *",
  "Tasty name": "Chutný názov",
  Description: "Popis",
  "Nice description": "Pekný popis",
  Price: "Cena",
  "Price ({0}) *": "Cena ({0}) *",
  "Enter price": "Vložte cenu",
  "Are you sure you want to delete this meal?":
    "Ste si istý, že chcete odstrániť toto jedlo?",
  "Once meal {0} is deleted, you will not be able to recover it!":
    "Po odstránení nebude možné jedlo {0} obnoviť!",
  "Meal Categories": "Kategórie jedál",
  "Meal Badges": "Nálepky",
  "Meal Allergens": "Alergény",
  "Image upload failed": "Nahrávanie súboru zlyhalo",
  "Image upload failed, missing network connection":
    "Nahrávanie súboru zlyhalo, chyba pripojenia",
  "Image upload failed, file is too large (max 3MB)":
    "Nahrávanie súboru zlyhalo, súbor je príliš veľký, maximálna veľkosť je 3MB",
  Upload: "Nahrať",
  Download: "Stiahnuť",
  "Rotate left": "Otočiť doľava",
  "Rotate right": "Otočiť doprava",

  // screens
  "Add screen": "Pridať obrazovku",
  "Remove screen": "Odstrániť obrazovku",
  "Screen {0}": "Obrazovka {0}",
  "Are you sure you want to delete this screen?":
    "Ste si istý, že chcete odstrániť túto obrazovku?",
  "Once screen {0} is deleted, you will not be able to recover it!":
    "Po odstránení nebude možné obrazovku {0} obnoviť!",

  // --> devices
  "Welcome in device": "Vitajte v zariadení",
  "Loading...": "Načítavám...",
  "Code for pairing device: ": "Kód zariadenia pre spárovanie",
  "Devices in project": "Zariadenia v projekte",
  "Add device": "Pridať zariadenie",
  "Pairing code from device": "Párovací kód zo zariadenia",
  "Pairing code add succeded": "Párovací kód úspešne pridaný",
  "Connected since {0}": "Pripojené od {0}",
  "Disconnected since {0}": "Nepripojené od {0}",
  "Never connected": "Nepripojené",
  "Device time is incorrect. {0} minutes difference":
    "Zariadenie má nastavený zlý čas. Odchýlka {0} minút",

  // templates
  "List black": "Zoznam čierny",
  "List white": "Zoznam biely",
  "List green": "Zoznam zelený",
  "Image lightgray": "Obrázok svetlošedý",
  "Image orange": "Obrázok oranžový",
  "Combined black": "Kombinované čierne",
  "Combined white": "Kombinované biele",

  // settings
  Location: "Prevádzka",
  "Location settings": "Nastavenia prevádzky",
  "Location name": "Meno prevádzky",
  Currency: "Mena",
  "Default image": "Predvolený obrázok",
  "Meals URL": "URL jedál",
  "Offer URL": "URL ponuky",
  "Currency URL": "URL meny",
  "Scheduling URL": "URL plánovania",
  "Configuration URL": "URL nastavení",
  "Manage locations": "Spravovať prevádzky",
  "Locations list": "Zoznam prevádzok",
  "Open location manager": "Otvoriť administráciu prevádzok",
  "Danger zone": "Nebezpečná zóna",
  "Delete location": "Odstrániť prevádzku",

  "Scheduler settings": "Nastavenia plánovača",
  "Time intervals": "Časové intervaly",
  "Time of the day": "Názov intervalu",
  From: "Od",
  To: "Do",
  Removed: "Odstránené",
  "Failed to change project hours settings.":
    "Nepodarilo sa zmeniť nastavenia plánovača",

  "User management": "Správa používateľov",
  Team: "Tím",
  member: "Člen tímu",
  admin: "Administrátor",
  "Account settings": "Nastavenia účtu",
  Language: "Jazyk",
  "Change password": "Zmeniť heslo",
  "Add user": "Pridaj používateľa",
  "Are you sure you want to delete this location?":
    "Ste si istý, že chcete odstrániť túto prevádzku?",
  "Once location {0} is deleted, you will not be able to recover it!":
    "Po odstránení nebude možné prevádzku {0} obnoviť!",
  "Are you sure you want to remove this member?":
    "Ste si istý, že chcete odobrať člena tímu?",
  "Once removed, {0} will no longer have granted access to manage this location!":
    "Po odobratí nebude mať {0} viac prístup k správe aktuálnej prevádzky!",
  "Device management": "Správa zariadení",
  "Are you sure you want to remove this device?":
    "Ste si istý, že chcete odobrať toto zariadenie?",
  "Once removed, device {0} will no longer have granted access to location data!":
    "Po odobratí nebude mať zariadenie {0} prístup k údajom aktuálnej prevádzky!",

  // project manager
  Locations: "Prevádzky",
  "Create location": "Vytvoriť prevádzku",
  "My new awesome location": "Moja nová úžasná prevádzka",
  "Fill with predefined data? (demo location)":
    "Predvyplniť ukážkovými dátami? (demo prevádzka)",

  // success messages
  "Add member success": "Pridanie používateľa úspešné",
  Saved: "Uložené",
  "Copied to clipboard": "Skopírované do schránky",

  // offers management
  "Offers management": "Nastavenia ponúk",
  "Offer settings": "Nastavenia ponuky",
  "Offer name": "Názov ponuky",
  "Go to Offer": "Prejsť na ponuku",
  Layout: "Vzhľad",
  Template: "Šablóna",
  "Change template": "Zmeniť šablónu",
  "Selected screens": "Vybrané obrazovky",
  "Add offer": "Pridať ponuku",
  "Active in days": "Platné v dňoch",
  "Active in hours": "Platné v časoch",
  "Are you sure you want to delete this offer?":
    "Ste si istý, že chcete vymazať túto ponuku?",
  "Once offer {0} is deleted, you will not be able to recover it!":
    "Po odstránení nebude možné ponuku {0} obnoviť!",
  "Offer saved": "Ponuka uložená",
  "Failed to save offer.": "Nepodarilo sa uložiť ponuku",
  "After midnight": "Po polnoci",
  Breakfast: "Raňajky",
  "Lunch time": "Obed",
  Afternoon: "Poobedie",
  Dinner: "Večera",
  "Before midnight": "Pred polnocou",

  // warnings
  "Sending action. Please be patient.": "Akcia sa odosiela, čakajte prosím.",
  Connected: "Pripojené",
  "Action takes too long. It will complete automatically once connection is reestablished. Do not close the app.":
    "Akcia trvá dlhšie ako obvykle. Po nadviazaní spojenia sa automaticky dokončí. Prosím, nezatvárajte aplikáciu.",
  "The start time must preceed end time": "Začiatok musí byť skôr ako koniec",
  "Other offers {1} are assigned to Screen {0} at the same time":
    "Obrazovka {0} má naplánované aj iné ponuky {1} v prekrývajúcom sa čase",
  'Other offers {1} assigned to Screen {0} have "Always presented" option ON':
    'Obrazovka {0} má nastavené "stále zobrazovať" aj na iných ponukách {1}',

  // general
  Save: "Uložiť",
  Submit: "Odoslať",
  Cancel: "Zrušiť",
  Remove: "Odobrať",
  Delete: "Odstrániť",
  Add: "Pridať",
  Edit: "Upraviť",
  "Show All": "Zobraziť všetky",
  "Clear All": "Zmazať všetky",
  Messages: "Správy",
  "Name (alphabetical)": "Názov (abecedne)",
  "Date update (from newest)": "Dátum úpravy (od najnovšieho)",
  "Sort by": "Triediť podľa",
  Select: "Vybrať",
  "Reset changes": "Vrátiť zmeny",
  "Always presented?": "Stále zobrazená?",
  Yes: "Áno",
  No: "Nie",
  "Choose filter values": "Vyberte hodnoty filtra",

  // tags: Badges
  Spicy: "Pikantné",
  "Gluten free": "Bezlepkové",
  Organic: "Organické",
  Special: "Špecialita",
  Vegan: "Vegánske",
  XL: "XL porcia",

  // tags: Allergens
  Wheat: "Pšenica",
  Crustaceans: "Kôrovce",
  Eggs: "Vajcia",
  Fish: "Ryby",
  Peanuts: "Arašidy",
  Soya: "Sója",
  Milk: "Mlieko",
  Nuts: "Orechy",
  Celery: "Zeler",
  Mustard: "Horčica",
  Sesame: "Sezam",
  Sulphur: "Síra",
  Lupin: "Vlčí bôb",
  Molluscs: "Mäkkýše",

  // Weekdays
  Monday: "Pondelok",
  Tuesday: "Utorok",
  Wednesday: "Streda",
  Thursday: "Štvrtok",
  Friday: "Piatok",
  Saturday: "Sobota",
  Sunday: "Nedeľa",

  LayoutListDefault: "Zoznam základný",
  LayoutListGreen: "Zoznam zelený",
  LayoutListWhite: "Zoznam biely",
  LayoutImageDefault: "Obrazkový základný",
  LayoutImageOrange: "Obrazkový oranžový",
  LayoutCombinedDefault: "Kombinovaný základný",
  LayoutCombinedBlack: "Kombinovaný čierny",
  LayoutImageDefaultWithNumber: "Obrazkový základný číslovaný",
  LayoutImageOrangeWithNumber: "Obrazkový oranžový číslovaný",
  LayoutImage3x3: "Obrazkový 3x3",

  "Failed to change location name.": "Nepodarilo sa zmeniť názov prevádzky.",
  "Failed to change currency setting.": "Nepodarilo sa zmeniť nastavenie meny.",
  "Failed to modify permissions.": "Nepodarilo sa zmeniť oprávnenia.",
  "Failed to change role to team member.":
    "Nepodarilo sa zmeniť rolu člena tímu.",
  "Cannot connect to server": "Nepodarilo sa nadviazať spojenie so serverom",

  //errors
  "user-not-found":
    "Používateľ so zadaným emailom neexistuje. Prosím skontrolujte, či je zadaný email správny a skúste to znova.",
  "wrong-password":
    "Zadané heslo je nesprávne. Ak ste zabudli svoje heslo kliknite na odkaz 'Zabudol som heslo' nižšie.",
  "network-request-failed":
    "Nastala chyba pripojenia k sieti. Prosím skontrolujte svoje pripojenie k internetu a skúste to znova.",
  "login-error":
    "Nastala chyba pri pokuse o prihlásenie. Ak problém pretrváva, prosím kontaktuje nás.",
  "google-auth-error": "Google prihlásenie zlyhalo.",
  "email-already-in-use": "Používateľské konto so zadaným emailom už existuje.",
  "signup-error":
    "Nastala chyba pri pokuse o vytvorenie konta. Ak problém pretrváva, prosím kontaktuje nás.",
  "read-project-error": "Nepodarilo sa pristúpiť k dátam prevádzky.",
  "read-device-data-error": "Nepodarilo sa načítať data, skúsim znova za 30s.",
  "reset-password-error":
    "Nastala chyba pri pokuse o obnovenie hesla. Ak problém pretrváva, prosím kontaktuje nás.",
  "duplicit-pairing-code":
    "Párovací kód sa nepodarilo pridať. Kód už bol pridaný.",
  "add-pairing-code-error": "Párovací kód sa nepodarilo pridať.",
  "save-device-name-error": "Nepodarilo sa uložiť názov zariadenia.",
  "remove-device-error": "Nepodarilo sa odobrať zariadenie z prevádzky.",
  "member-already-exists":
    "Nepodarilo sa pridať člena tímu. Člen tímu už existuje.",
  "add-member-error": "Nepodarilo sa pridať nového člena tímu.",
  "remove-member-error": "Nepodarilo sa odobrať člena tímu.",
  "create-meal-error": "Nepodarilo sa vytvoriť jedlo.",
  "edit-meal-error": "Nepodarilo sa upraviť jedlo.",
  "remove-meal-error": "Nepodarilo sa odobrať jedlo.",
  "save-meals-sortby-error":
    "Nepodarilo sa uložiť nastavenie pre zoradenie jedál",
  "modify-offer-error": "Nepodarilo sa upraviť ponuku.",
  "add-to-offer-error": "Nepodarilo sa upraviť ponuku.",
  "remove-from-offer-error": "Nepodarilo sa upraviť ponuku.",
  "create-demo-error": "Nepodarilo sa vytvoriť prevádzku.",
  "create-project-error": "Nepodarilo sa vytvoriť prevádzku.",
  "add-screen-error": "Nepodarilo sa pridať obrazovku.",
  "remove-screen-error": "Nepodarilo sa odobrať obrazovku.",
  "set-lang-error": "Nepodarilo sa zmeniť nastavenie jazyka.",
  "remove-project-error": "Nepodarilo sa odobrať prevádzku.",
  "save-offer-error": "Nepodarilo sa uložiť ponuku.",
  "remove-offer-error": "Nepodarilo sa odstrániť ponuku."
}
